const CATEGORY_ICON_BY_KEY = {
  'microcontroller-8bit': '\uD83D\uDD27',
  'microcontroller-16bit': '\u2699\uFE0F',
  'microcontroller-32bit': '\uD83D\uDD29',
  'development-board': '\uD83D\uDCF1',
  'sensor-module': '\uD83D\uDCE1',
  'communication-ic': '\uD83D\uDCF6',
  'power-management': '\u26A1',
  'memory-storage': '\uD83D\uDCBE',
  'custom-other': '\uD83D\uDD27'
};

const MICROCONTROLLER_CATEGORIES = new Set([
  'microcontroller-8bit',
  'microcontroller-16bit',
  'microcontroller-32bit'
]);

export const getBoardCategoryIcon = (category) => CATEGORY_ICON_BY_KEY[category] || '';
export const isMicrocontrollerCategory = (category) => MICROCONTROLLER_CATEGORIES.has(category);
